import React, { PropsWithChildren } from "react";
import { ThemeProvider } from "@primer/react";
import { StyleSheetManager } from "styled-components";
import ErrorHandler from "./ErrorHandler";

// Lighter sibling of PrimerRoot. Use this when a Stimulus mount renders
// Primer components but BaseStyles is either provided downstream (e.g.
// the child wraps itself in GregPrimerTheme) or would interfere with
// layout (sticky positioning, table-cell rendering, double-wrapping a
// component that already mounts its own BaseStyles).
//
// Carries the same disableCSSOMInjection guard as PrimerRoot — see that
// file for the Turbo head-merge mechanism — and a ThemeProvider so sx
// theme tokens resolve, but skips BaseStyles to avoid an extra <div>
// wrapper.
export default function PrimerStyleGuard({ children }: PropsWithChildren): React.ReactElement {
  return (
    <ErrorHandler>
      <StyleSheetManager disableCSSOMInjection>
        <ThemeProvider>{children}</ThemeProvider>
      </StyleSheetManager>
    </ErrorHandler>
  );
}
